module.exports = InternalShared('InternalShared/Events/DuplicateFieldEvent');